/**
 * Enum of widgets types
 */
export const DASHBOARD = "Dashboard"
export const SELECTOR = "Selector"
export const BOOKMARK = "Bookmark"
export const TEMPLATE = "Template"

/**
 * Object of all available widget types
 */
export const WIDGET_TYPES = { DASHBOARD, SELECTOR, BOOKMARK, TEMPLATE }
